// A function that takes in a string and cleanses unwanted input
const cleanseDomain = (domain: string) => {
	let cleansedDomain = domain.toLowerCase();
	
	if (cleansedDomain.includes('www.')) {
		cleansedDomain = cleansedDomain.slice(cleansedDomain.indexOf('.') + 1);
	}
	
	if (cleansedDomain.includes('.')) {
		cleansedDomain = cleansedDomain.slice(0, cleansedDomain.indexOf('.'));
	}
	
	cleansedDomain = cleansedDomain.replace(/[^a-zÀ-ÖØ-öø-ÿ0-9-]/g, '');
	
	cleansedDomain = cleansedDomain.replace(/-{2,}/g, '-');
	
	cleansedDomain = cleansedDomain.replace(/^-|-$/g, '');
	
	cleansedDomain = cleansedDomain.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	
	return cleansedDomain;
};

export default cleanseDomain;
